module.exports = __webpack_public_path__ + "img/memberTwitter.b4afa77e.png";